import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import * as React from 'react';
import classnames from 'classnames';
import ExtendedPropTypes from '@insolus/prop-types';
import Link from "@insolus/ui-kit/components/Link";
import SidebarItem from '../Item';

var SidebarDropdown = function (_React$Component) {
  _inherits(SidebarDropdown, _React$Component);

  var _super = _createSuper(SidebarDropdown);

  function SidebarDropdown() {
    var _this;

    _classCallCheck(this, SidebarDropdown);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      open: false
    };

    _this.handleToggle = function () {
      _this.setState(function (prevState) {
        return {
          open: !prevState.open
        };
      });
    };

    return _this;
  }

  _createClass(SidebarDropdown, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          icon = _this$props.icon,
          title = _this$props.title,
          children = _this$props.children;

      var _className = classnames('SidebarDropdown', {
        'SidebarDropdown--open': this.state.open
      });

      return React.createElement("li", {
        className: _className
      }, React.createElement(Link, {
        icon: icon,
        onClick: this.handleToggle
      }, title), React.createElement("ul", {
        className: "SidebarDropdown__dropdown"
      }, children));
    }
  }]);

  return SidebarDropdown;
}(React.Component);

SidebarDropdown.displayName = 'Sidebar.Dropdown';
export default SidebarDropdown;